
export const SET_ROUTE = 'SET_ROUTE';
